import { HYDRATE } from 'next-redux-wrapper';

import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';
import { IRegionsWithCitiesGroup, IRegionWithCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';

import {
    ECitySelect,
    TCloseCitySelect,
    TOpenCitySelect,
    TSetRegions,
    TSetSatellites,
    TSetSelectedRegion,
    TSetTopCities,
} from '~/src/components/CitySelectContainer/store/actionCreators';
import { THydrateAction } from '~/src/store';


export interface ICitySelectState {
    isOpen: boolean,
    regions: IRegionsWithCitiesGroup,
    topCities: ICitySatellite[],
    satellites: ICitySatellite[],
    selectedRegion: IRegionWithCities | null,
}

export const initialState: ICitySelectState = {
    isOpen: false,
    regions: {},
    topCities: [],
    satellites: [],
    selectedRegion: null,
};

export type TCitySelectAction =
    | TOpenCitySelect
    | TSetRegions
    | TSetTopCities
    | TSetSatellites
    | TSetSelectedRegion
    | TCloseCitySelect

const citySelect = (state = initialState, action: TCitySelectAction | THydrateAction): ICitySelectState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.citySelect };
        case ECitySelect.OPEN_CITYSELECT:
            return {
                ...state,
                isOpen: true,
            };
        case ECitySelect.SET_REGIONS:
            return {
                ...state,
                regions: action.payload,
            };
        case ECitySelect.SET_TOP_CITIES:
            return {
                ...state,
                topCities: action.payload,
            };
        case ECitySelect.SET_SATELLITES:
            return {
                ...state,
                satellites: action.payload,
            };
        case ECitySelect.SET_SELECTED_REGION:
            return {
                ...state,
                selectedRegion: action.payload,
            };
        case ECitySelect.CLOSE_CITYSELECT:
            return {
                ...state,
                isOpen: false,
                selectedRegion: null,
            };
        default:
            return state;
    }
};

export default citySelect;
